// extracted by mini-css-extract-plugin
module.exports = {"recipetoaster":"Toaster_recipetoaster__13g8K"};